import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Productpost from './API/Productpost';
import Loader from './UI/Loader/Loader';

const ProductList = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            setLoading(true);
            const response = await Productpost.getProducts();
            console.log(response);
            if (response && response.data && response.data.success) {
                setProducts(response.data.data);
            } else {
                setError('Помилка завантаження товарів');
            }
        } catch (error) {
            console.error('Error fetching products:', error);
            setError('Помилка завантаження товарів');
        } finally {
            setLoading(false);
        }
    };

        if (loading) return <Loader />;
        if (error) return <div className="error-message" style={{ fontFamily: 'Inter, sans-serif' }}>{error}</div>;

        return (
            <div className="product-list" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
                    <div className="product-grid" style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
                gap: '20px' 
            }}>
                {products.map(product => {
                    const images = product.images ? JSON.parse(product.images) : [];
                    const firstImage = images.length > 0 ? images[0] : null;
                    
                    return (
                        <Link 
                            key={product.id} 
                            to={`/Product/${product.id}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="product-card" style={{
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}
                            >
                                {firstImage && (
                                    <img 
                                        src={firstImage} 
                                        alt={product.name}
                                        style={{ 
                                            width: '100%', 
                                            height: '200px', 
                                            objectFit: 'cover' 
                                        }}
                                    />
                                )}
                                
                                <div style={{ padding: '15px' }}>
                                    <h3 style={{ 
                                        marginBottom: '10px',
                                        fontSize: '18px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        {product.name}
                                    </h3>
                                    
                                    {product.description && (
                                        <p style={{ 
                                            color: '#666',
                                            fontSize: '14px',
                                            marginBottom: '10px',
                                            overflow: 'hidden',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: 'vertical',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {product.description}
                                        </p>
                                    )}
                                    
                                    <div className="price" style={{ 
                                        fontSize: '20px', 
                                        fontWeight: 'bold', 
                                        color: '#4CAF50',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        {parseFloat(product.price).toLocaleString()} ₴
                                    </div>
                                    
                                    {product.category && (
                                        <div style={{ 
                                            marginTop: '10px',
                                            padding: '4px 8px',
                                            backgroundColor: '#f0f0f0',
                                            borderRadius: '4px',
                                            fontSize: '12px',
                                            display: 'inline-block',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {product.category}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
            
            {products.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                    <p style={{ fontFamily: 'Inter, sans-serif' }}>Товари не знайдено</p>
                </div>
            )}
        </div>
    );
};

export default ProductList;